<script setup>
import { computed } from 'vue';
import { LEVELLING_STATUS } from '@rm-ui/levelling/levellingMeta';

const props = defineProps({
  status: { type: String, default: 'not-started' },
});

const meta = computed(() => LEVELLING_STATUS[props.status] || LEVELLING_STATUS['not-started']);
</script>

<template>
  <span class="cc-pill" :class="'cc-pill--' + meta.tone">
    <span class="ms cc-pill-icon">{{ meta.icon }}</span>
    {{ meta.label }}
  </span>
</template>

<style lang="scss" scoped>
/* Prototype v3-spill2 — 12.5px/650, 4px 11px. */
.cc-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 11px;
  border-radius: 999px;
  font-size: 12.5px;
  font-weight: 650;
  white-space: nowrap;
  border: 1px solid transparent;

  .cc-pill-icon {
    font-size: 14px;
    color: inherit !important;
  }

  &.cc-pill--todo {
    color: var(--cc-todo-fg, #5a6678);
    background: var(--cc-todo-bg, #f1f3f6);
    border-color: var(--cc-todo-bd, #e2e6ec);
  }
  &.cc-pill--teal {
    color: var(--cc-teal-fg, #0d6e96);
    background: var(--cc-teal-bg, #e8f4fb);
    border-color: var(--cc-teal-bd, #cfe8f5);
  }
  &.cc-pill--accent {
    color: var(--cc-acc-fg, #1d5bd6);
    background: var(--cc-acc-bg, #e9f0fd);
    border-color: var(--cc-acc-bd, #d4e2fb);
  }
  &.cc-pill--warn {
    color: var(--cc-warn-fg, #8a6a00);
    background: var(--cc-warn-bg, #fbf4e0);
    border-color: var(--cc-warn-bd, #f3e6bd);
  }
  &.cc-pill--violet {
    color: var(--cc-violet-fg, #6d5ae6);
    background: var(--cc-violet-bg, #efecfc);
    border-color: var(--cc-violet-bd, #ded8f9);
  }
  &.cc-pill--green {
    color: var(--cc-ok-fg, #1f7a53);
    background: var(--cc-ok-bg, #e8f6ee);
    border-color: var(--cc-ok-bd, #cfeadd);
  }
}
</style>
